/**
 * Hand-maintained stub overrides.
 *
 * This file is NOT generated — it lives at the package root (outside `src/`),
 * so `yarn sync-entities` never clobbers it. The stub generator
 * (`scripts/sync-entities/sync-stubs.ts`) reads it and, for any
 * `[entity][field]` listed here, overrides that field in every generated stub
 * factory (centralized and per-app). A field with no entry keeps the default
 * baked-in placeholder.
 *
 * Each override is one of two kinds:
 *
 * - **A value** (`string | number | boolean | null | array`). The stub
 *   *references this value at runtime* — e.g.
 *   `freeTimeUpdatedAt: stubConfig.Calendar.freeTimeUpdatedAt`. Because the stub
 *   references it (rather than baking a copy), a value computed here is resolved
 *   when this module loads at test time, so a relative date stays correct
 *   without regenerating. Use it to pin a specific value: a future date, a
 *   particular enum/flag, a single-element enum array, etc.
 *
 * - **An array-length directive** (`{ length: N }`). Only the element *count* of
 *   an array field is overridden — the stub still calls its own sibling
 *   `<Child>Stub()`, so per-app slice typing is preserved. Use it for fields
 *   that are conceptually single-element lists (e.g. a user's `settings`), where
 *   a shared value can't satisfy each app's narrower ref type.
 *
 *   export const stubConfig = {
 *     Calendar: { freeTimeUpdatedAt: new Date('2099-01-01').toISOString() },
 *     User: { settings: { length: 1 } },
 *   } satisfies StubConfig;
 *
 * Keys are entity names and own field names exactly as they appear on the
 * generated entity (e.g. `Calendar`, `freeTimeUpdatedAt`). Adding/removing an
 * entry requires a `yarn sync-entities` to (un)wire it in the stubs; changing
 * an existing value does not. Overrides for an entity/field that isn't in an
 * app's slice are simply ignored.
 */
// Imported relatively, not from `@axiom/domain` — the package can't import its
// own name here.
import { Role } from './src/enums';

/** A single field override: a literal value (referenced at runtime), or an
 *  array-length directive `{ length }` (applied at generation time). */
export type StubOverride =
  | string
  | number
  | boolean
  | null
  | readonly unknown[]
  | { readonly length: number };

export type StubConfig = Record<string, Record<string, StubOverride>>;

// `satisfies` (not a type annotation) so the stub generator and the generated
// stubs see the precise literal shape — `stubConfig.Calendar.freeTimeUpdatedAt`
// stays a concrete, defined value rather than a possibly-undefined index access.
export const stubConfig = {
  Calendar: {
    timezone: 'Africa/Abidjan',
  },
  User: {
    // `roles` is a Role[] but in practice a user almost always has a single
    // role — pin one value rather than the default first-three placeholder.
    roles: [Role.EnvoyUser],
    // A user almost always has a single settings row — keep the sibling stub,
    // just emit one element instead of three.
    settings: { length: 1 },
  },
} satisfies StubConfig;
